// Copyright (c) 2022 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import ClosingAccountDetails from './closing-account-details';
import ClosingAccountSearchDealer from '../../state/closing-account-search-account';
import ClosingAccountSortOptions from '../../services/closing-account-sort-options';
import ConfirmationModal from '../../../../shared/components/confirmation-modal';
import {FormattedMessage} from 'react-intl';
import RefinableListWidget from '../../../../shared/components/refinable-list-widget';
import SearchFilters from '../../../../shared/state/search-filters';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDealer} from '../../../../shared/services/build-dealer';
import {getDefaultState as getDealerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/dealer';

function handleAccountLookupChange(accountlookup, index) {

    const overrideAccountUpdation = this.closingAccountChanges[index];

    overrideAccountUpdation.accountLookup = accountlookup;

    this.actions.updateOverrideAccount(overrideAccountUpdation);

}

function handleAccountLookupBlur(account, index) {

    this.actions.readDealer(account, index, this.closingAccountChanges);

}

function handleOpenConfirmationModal(index) {

    document.body.classList.add('warranty-modal-is-open');
    this.actions.updateDealerSearchModalVisibility(this.isModalVisible);
    this.actions.updateCloseAccountIndex(index);

}

function handleCloseConfirmationModal() {

    document.body.classList.remove('warranty-modal-is-open');
    this.actions.updateDealerSearchModalVisibility(this.isModalVisible);
    this.actions.updateCloseAccountIndex(0);

}

function handleResetTransferClick(index) {

    const overrideAccountUpdation = this.closingAccountChanges[index];

    const overrideAccount = getDealerDefaultState();

    overrideAccountUpdation.overrideAccount = overrideAccount;

    this.actions.resetNewTransfer(overrideAccountUpdation);

}

function handleOverrideAccountUpdate(account) {

    const overrideAccountUpdation = this.closingAccountChanges[this.accountIndex];

    overrideAccountUpdation.overrideAccount = account;

    this.actions.updateOverrideAccount(overrideAccountUpdation);

    this.actions.updateCloseAccountIndex(0);

}
class ClosingAccountList extends Component {
    state = {
        accountIndexLocal: 0,
        showConfirmTransfer: false
    };

    handleOpenConfirmationPopup= index => {

        document.body.classList.add('warranty-modal-is-open');

        this.setState({
            accountIndexLocal: index,
            showConfirmTransfer: true
        });

    }

    handleCloseConfirmationPopup= () => {

        document.body.classList.remove('warranty-modal-is-open');
        this.setState({showConfirmTransfer: false});

    };

    handleAcceptClosingAccount = () => {

        document.body.classList.remove('warranty-modal-is-open');
        const indexPassed = this.state.accountIndexLocal;
        const closingAccountAccept = this.props.closingAccountChanges[indexPassed];
        const closingAccountRestructure = {};

        closingAccountRestructure.account = closingAccountAccept.account;
        closingAccountRestructure.accountEndDate = closingAccountAccept.accountEndDate;
        closingAccountRestructure.businessEndDate = closingAccountAccept.businessEndDate;

        if (closingAccountAccept.overrideAccount.account === '') {

            closingAccountRestructure.newAccount = closingAccountAccept.newAccount;

        } else {

            closingAccountRestructure.newAccount = closingAccountAccept.overrideAccount;

        }

        this.props.actions.acceptClosingAccount(closingAccountRestructure, this.props.selectedDealers);

        this.setState({showConfirmTransfer: false});

    };

    render() {

        return (

            <div>
                <RefinableListWidget
                    onFilterByChange={this.props.updateListFilterBy}
                    onSortByChange={this.props.updateListSortBy}
                    onSortDirectionChange={this.props.updateListSortDirection}
                    searchFilters={this.props.closingAccountSearchFilters}
                    sortOptions={ClosingAccountSortOptions}
                />
                {this.props.closingAccountChanges.map((closingAccount, index) =>
                    <section
                        className='closing-account-result'
                        key={index}
                    >

                        <div >
                            <span
                                className='responsible-account'
                            >
                                {buildDealer(closingAccount.account, this.context.user.settings.dealer.displayFormat.key)}
                            </span>
                            <div
                                className='account-status'
                            >
                                <span
                                    className='dot-icon-red'
                                />
                                <FormattedMessage
                                    id={closingAccount.status}
                                ></FormattedMessage>

                            </div>
                        </div>

                        <section>
                            <ClosingAccountDetails
                                actions={this.props.actions}
                                closingAccountChanges={closingAccount}
                                dealerSearchModal={this.props.dealerSearchModal}
                                icon={this.props.icon}
                                index={index}
                                key={closingAccount.account.account}
                                onAccountLookupBlur={this.props::handleAccountLookupBlur}
                                onAccountLookupChange={this.props::handleAccountLookupChange}
                                onCloseClick={this.props::handleCloseConfirmationModal}
                                onDealerSearchViewClick={this.props::handleOpenConfirmationModal}
                                onResetClick={this.props::handleResetTransferClick}
                                updateOverrideAccount={this.props::handleOverrideAccountUpdate}
                            />
                        </section>
                        <footer>
                            <section>
                                {closingAccount.status === 'NEW' &&
                                <div className='button-group'>
                                    <button
                                        className='primary'
                                        onClick={() => this.handleOpenConfirmationPopup(index)}
                                    >
                                        <FormattedMessage id='ACCEPT'/>
                                    </button>
                                </div>
                                }
                            </section>
                        </footer>
                        { index === 0 ?
                            <ConfirmationModal
                                confirmMessage='CONFIRM_CLOSING_ACCOUNT'
                                isOpen={this.state.showConfirmTransfer}
                                onClose={this.handleCloseConfirmationPopup}
                                onConfirm={this.handleAcceptClosingAccount}
                                title='CLOSING_ACCOUNT'
                            /> : null }
                    </section>
        )}
            </div>
        );

    }
}

ClosingAccountList.displayName = 'ClosingAccountList';
ClosingAccountList.propTypes = {
    accountIndex: PropTypes.number,
    actions: PropTypes.object.isRequired,
    closePopup: PropTypes.func,
    closingAccountChanges: PropTypes.arrayOf(PropTypes.instanceOf(ClosingAccountSearchDealer)).isRequired,
    closingAccountSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    dealerSearchModal: PropTypes.bool.isRequired,
    icon: PropTypes.bool,
    isModalVisible: PropTypes.bool,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(String)),
    updateListFilterBy: PropTypes.func.isRequired,
    updateListSortBy: PropTypes.func.isRequired,
    updateListSortDirection: PropTypes.func.isRequired
};
ClosingAccountList.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};
export default ClosingAccountList;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/closing-account/closing-account-list.js